import styled from "styled-components";

export const PricingPageWrapper = styled.div`
  padding-bottom: 25px;
`;
